import React, { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader, Icon } from '@salesforce/design-system-react';
import { Button, ButtonGroup, PageHeaderControl } from '@salesforce/design-system-react';
import Modal from '@salesforce/design-system-react/components/modal';
import { getCurrentUser } from '../../../../services/auth';
import { getSyncTime } from '../../../../services/snapshot';
import { networkSelector, updateNetwork } from '../../../../store/network/slice';
import { toast, Toaster } from 'react-hot-toast';
import ChainList from './chainList';

const Network = () => {
  const [showUpdateConfirm, setShowUpdateConfirm] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const { networks, loading, success } = useSelector(networkSelector);
  const dispatch = useDispatch();
  const user = getCurrentUser();
  const isSnapshot = useMemo(() => !!getSyncTime(), []);

  useEffect(() => {
    if (success && showToast) {
      toast.success(
        `${networks.filter((network) => network.selected).length} networks successfully updated`,
        {
          id: 'network-update',
        }
      );
      setShowToast(false);
      toggleOpen();
    }
  }, [success, showToast]);

  const toggleOpen = () => {
    setShowUpdateConfirm(false);
  };

  const handleUpdateNetwork = () => {
    setShowToast(true);
    const selectedChains = networks
      .filter((network) => network.selected)
      .map((network) => network.id);
    dispatch(updateNetwork({ chains: selectedChains }));
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <div>
        <PageHeader
          icon={
            <Icon
              assistiveText={{ label: 'User' }}
              category="standard"
              name="catalog"
              containerStyle={{
                backgroundColor: '#48C3CC',
              }}
            />
          }
          label="Networks"
          title="Network Chain Selection"
          variant="record-home"
          onRenderActions={() => (
            <>
              {((user.account_type === 'organization' && user.role !== 'user') ||
                user.account_type === 'standard') && (
                <PageHeaderControl>
                  <ButtonGroup id="button-group-page-header-actions">
                    <Button
                      label={'Chain Update'}
                      onClick={() => setShowUpdateConfirm(true)}
                      disabled={isSnapshot}
                    />
                  </ButtonGroup>
                </PageHeaderControl>
              )}
            </>
          )}
        />
      </div>
      <ChainList />
      <Modal
        ariaHideApp={false}
        isOpen={showUpdateConfirm}
        size="small"
        containerClassName="small-modal"
        footer={[
          <Button className='modal-cancel-button' key="cancel" label="Cancel" onClick={toggleOpen} />,
          <Button
            className='modal-save-button'
            key="save"
            label={loading ? <span>Loading</span> : <span>{'Confirm'}</span>}
            disabled={loading}
            onClick={handleUpdateNetwork}
          />,
        ]}
        onRequestClose={toggleOpen}
        heading={'Update network'}
      >
        <section className="slds-p-around_large">
          <p className="mb-10">Are you sure you want to update this network?</p>
        </section>
      </Modal>
    </>
  );
};

export default Network;
